import { Button } from 'antd';
import { useTranslation } from 'react-i18next';

import ErrorState from '@/UI/ErrorState/ErrorState';

const Error = () => {
  const [t] = useTranslation();

  return (
    <ErrorState
      fullPage
      title={t('ERROR_MESSAGE')}
      action={
        <Button onClick={() => window.location.reload()}>
          {t('RELOAD_PAGE')}
        </Button>
      }
    />
  );
};

export default Error;
